import { useRef, useEffect } from 'react';
import { playCorrectSound, playIncorrectSound, playTickSound } from '../utils/sound';

interface UseRushSoundsArgs {
  timeRemaining: number;
  isTimerActive: boolean;
  answerCorrect: boolean | null;
}

export function useRushSounds({ timeRemaining, isTimerActive, answerCorrect }: UseRushSoundsArgs): void {
  const lastTickedSecond = useRef<number | null>(null);
  const prevAnswerCorrect = useRef<boolean | null>(null);

  // Answer sounds: detect null → true/false transition
  useEffect(() => {
    if (answerCorrect !== null && prevAnswerCorrect.current === null) {
      if (answerCorrect) {
        playCorrectSound();
      } else {
        playIncorrectSound();
      }
    }
    prevAnswerCorrect.current = answerCorrect;
  }, [answerCorrect]);

  // Tick sounds in last 5 seconds
  useEffect(() => {
    if (!isTimerActive) {
      lastTickedSecond.current = null;
      return;
    }

    const secondsLeft = Math.ceil(timeRemaining / 1000);

    if (secondsLeft >= 1 && secondsLeft <= 5 && secondsLeft !== lastTickedSecond.current) {
      lastTickedSecond.current = secondsLeft;
      const urgency = 5 - secondsLeft; // 0 at 5s, 4 at 1s
      playTickSound(urgency);
    }
  }, [timeRemaining, isTimerActive]);
}
